/**
 * clipboardMixin
 *
 * Provides clipboard copy functionality for sharing a pre-filtered page URL.
 *
 * ## Usage
 *
 *   import clipboardMixin from '../../mixins/clipboardMixin.js'
 *
 *   export default {
 *     mixins: [clipboardMixin],
 *     ...
 *   }
 *
 * ## Required method (implement in the component)
 *
 *   buildClipboardUrl(version) {String}
 *     Returns the full URL to copy, with the version pre-filled as a search param.
 *
 *     Example:
 *       buildClipboardUrl (version) {
 *         return `${window.location.origin}/pt-firmware?search=${version}`
 *       }
 *
 * ## Methods provided
 *
 *   copyToClipboard(version)
 *     Calls buildClipboardUrl(version) and writes the result to the clipboard.
 */

export default {
  methods: {
    copyToClipboard (version) {
      const url = this.buildClipboardUrl(version)
      navigator.clipboard.writeText(url).then(() => {
        console.log('URL copied to clipboard')
      }).catch(() => {
        console.error('Failed to copy URL to clipboard')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/clipboardMixin.js